// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"355":"df852166","722":"266f21e5","767":"99b44698","771":"700fce98","795":"d504cbd3"}[chunkId] + ".js";
};